import {deserialize} from '$app/forms';
import type {Action} from 'svelte/action';

/**
 * Добавляет событие click_outside
 */
export const clickOutside: Action<HTMLElement> = function (node) {
    const handleClick = (event: any) => {
        if (node && !node.contains(event.target) && !event.defaultPrevented) {
            node.dispatchEvent(new CustomEvent('click_outside', {detail: node}));
        }
    };

    document.addEventListener('click', handleClick, true);

    return {
        destroy() {
            document.removeEventListener('click', handleClick, true);
        },
    };
};

/**
 * Поведение элемента как ссылки - открытие ссылки по клику или колесику
 * Не передает переход дальше по статистикам и прочему
 */
export const asLink: Action<HTMLElement, string | {url: string; target?: string}> = function (node, options) {
    let url = typeof options === 'string' ? options : options.url;
    let target = typeof options === 'string' ? '_blank' : options.target;

    node.setAttribute('data-as-link', url);

    const listener = function (e: Event) {
        window.open(url, target, 'noopener,noreferrer');
    };

    node.addEventListener('click', listener);

    return {
        update(options) {
            url = typeof options === 'string' ? options : options.url;
            target = typeof options === 'string' ? '_blank' : options.target;

            node.setAttribute('data-as-link', url);
        },

        destroy() {
            node.removeEventListener('click', listener);
        },
    };
};

/**
 * Вызов sveltekit action
 */
export async function callAction<T extends Record<string, unknown> | undefined, F extends Record<string, unknown> | undefined>(
    action: string,
    data: Record<string, any>
) {
    const fd = new FormData();

    for (const [key, value] of Object.entries(data)) {
        fd.append(key, value);
    }

    const res = await fetch(`?/${action}`, {
        method: 'POST',
        body: fd,
    });

    return deserialize<T, F>(await res.text());
}
